/* Scalypin theme script: navigation, tabs, TOC, forms, consent-aware Pinterest tracking. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.remove('no-js');
  doc.classList.add('js');
  var CFG = window.SCALYPIN || {};

  /* ---------- Header state ---------- */
  var header = document.querySelector('[data-sp-header]');
  var sticky = document.querySelector('[data-sp-sticky-cta]');
  var ticking = false;
  function onScroll() {
    ticking = false;
    var y = window.scrollY || 0;
    if (header) header.classList.toggle('is-scrolled', y > 8);
    if (sticky) {
      var blockers = false;
      document.querySelectorAll('.sp-form-card, .sp-footer').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) blockers = true;
      });
      sticky.classList.toggle('is-visible', y > 560 && !blockers);
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- Dropdowns ---------- */
  var dropdownItems = document.querySelectorAll('[data-sp-dropdown]');
  function closeAll(except) {
    dropdownItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var b = item.querySelector('button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  dropdownItems.forEach(function (item) {
    var btn = item.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !item.classList.contains('is-open');
      closeAll(item);
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    item.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches) { closeAll(item); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
    item.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover: hover)').matches) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  });
  document.addEventListener('click', function () { closeAll(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeMobile(); }
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-sp-burger]');
  var mobileNav = document.getElementById('sp-mobile-nav');
  function closeMobile() {
    if (!burger || !mobileNav) return;
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    mobileNav.classList.remove('is-open');
    document.body.classList.remove('nav-open');
  }
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') !== 'true';
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobileNav.classList.toggle('is-open', open);
      document.body.classList.toggle('nav-open', open);
    });
    mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMobile); });
  }

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-sp-tabs]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('[role="tab"]');
    function select(idx) {
      btns.forEach(function (b, j) {
        var on = j === idx;
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(i); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length;
          select(n); btns[n].focus();
        }
      });
    });
  });

  /* ---------- Article table of contents ---------- */
  var article = document.querySelector('[data-sp-article]');
  var toc = document.querySelector('[data-sp-toc]');
  if (article && toc) {
    var heads = article.querySelectorAll('h2');
    if (heads.length < 2) {
      toc.hidden = true;
    } else {
      var ol = document.createElement('ol');
      heads.forEach(function (h, i) {
        if (!h.id) h.id = (h.textContent || 'section').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section-' + i;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent;
        li.appendChild(a); ol.appendChild(li);
      });
      toc.appendChild(ol);
      if ('IntersectionObserver' in window) {
        var links = toc.querySelectorAll('a');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); });
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }
  } else if (toc) {
    toc.hidden = true;
  }

  /* ---------- Reveal on scroll (content is visible without JS) ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.sp-reveal').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('is-in'); } else { revealIO.observe(el); }
    });
  } else {
    document.querySelectorAll('.sp-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Tracking ---------- */
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'sp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  var Scalypin = window.Scalypin = window.Scalypin || {};
  var PIN_EVENTS = { lead_submitted: 'lead', booking_scheduled: 'lead', newsletter_signup: 'signup', whatsapp_click: 'custom' };
  var pending = [];
  function publishShopify(name, data) {
    /* Custom event for a Shopify Customer Events pixel (consent handled by Shopify). */
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('scalypin_' + name, data);
      }
    } catch (e) { /* no-op */ }
  }
  function sendPinterest(name, data) {
    var ev = PIN_EVENTS[name];
    if (!ev) return;
    if (typeof window.pintrk === 'function') {
      window.pintrk('track', ev, { event_id: data.event_id, lead_type: data.lead_type || name });
    } else if (CFG.pinterestTagId) {
      pending.push([name, data]);
    }
  }
  Scalypin.track = function (name, data) {
    data = data || {};
    publishShopify(name, data);
    sendPinterest(name, data);
  };
  function flushPending() { var list = pending.splice(0); list.forEach(function (p) { sendPinterest(p[0], p[1]); }); }

  function loadPinterestTag() {
    var id = (CFG.pinterestTagId || '').trim();
    if (!id || window.pintrk) return;
    /* Pinterest base tag, loaded only after marketing consent */
    !function (e) { if (!window.pintrk) { window.pintrk = function () { window.pintrk.queue.push(Array.prototype.slice.call(arguments)); }; var n = window.pintrk; n.queue = [], n.version = '3.0'; var t = document.createElement('script'); t.async = !0, t.src = e; var r = document.getElementsByTagName('script')[0]; r.parentNode.insertBefore(t, r); } }('https://s.pinimg.com/ct/core.js');
    window.pintrk('load', id);
    window.pintrk('page');
    window.pintrk('track', 'pagevisit', { event_id: uuid() });
    flushPending();
  }
  function marketingAllowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; }
  }
  function initConsent() {
    if (!CFG.pinterestTagId) return;
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return;
        if (marketingAllowed()) loadPinterestTag();
      });
    }
    document.addEventListener('visitorConsentCollected', function (ev) {
      if (ev && ev.detail && ev.detail.marketingAllowed) loadPinterestTag();
    });
  }
  initConsent();

  /* ---------- Lead forms ---------- */
  var params = new URLSearchParams(window.location.search);
  var interest = params.get('interest');
  document.querySelectorAll('[data-sp-lead-form]').forEach(function (form) {
    var eid = form.querySelector('[data-event-id]');
    if (eid && !eid.value) eid.value = uuid();
    var sel = form.querySelector('select[data-interest]');
    if (sel && interest) {
      var opt = sel.querySelector('option[value="' + interest.replace(/[^a-z-]/g, '') + '"]');
      if (opt) sel.value = opt.value;
    }
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); }
      try { sessionStorage.setItem('sp_lead_eid', eid ? eid.value : ''); } catch (e) { /* storage unavailable */ }
    });
  });
  var success = document.querySelector('[data-sp-lead-success]');
  if (success) {
    var storedId = '';
    try { storedId = sessionStorage.getItem('sp_lead_eid') || ''; sessionStorage.removeItem('sp_lead_eid'); } catch (e) { /* storage unavailable */ }
    Scalypin.track('lead_submitted', { event_id: storedId || uuid(), lead_type: 'Strategy call request', page: window.location.pathname });
    success.scrollIntoView({ block: 'center' });
  }
  if (document.querySelector('[data-sp-newsletter-success]')) {
    Scalypin.track('newsletter_signup', { event_id: uuid(), lead_type: 'Newsletter' });
  }

  /* ---------- Booking calendar conversions (Calendly / Cal.com) ---------- */
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    var scheduled = d.event === 'calendly.event_scheduled' || d.type === 'bookingSuccessful' || (typeof d.fullType === 'string' && /bookingSuccessful/.test(d.fullType));
    if (scheduled) Scalypin.track('booking_scheduled', { event_id: uuid(), lead_type: 'Booked strategy call' });
  });

  /* ---------- Booking pop-up and WhatsApp ---------- */
  var BOOK = CFG.booking || {};
  var bookUrl = (BOOK.url || '').trim();
  var WA = (CFG.whatsapp || '').trim();
  function embedUrl(raw) {
    var u;
    try { u = new URL(raw, window.location.href); } catch (e) { return raw; }
    var host = u.hostname;
    if (/calendly\.com$/.test(host)) {
      u.searchParams.set('embed_domain', window.location.hostname);
      u.searchParams.set('embed_type', 'Inline');
      u.searchParams.set('hide_gdpr_banner', '1');
      if (!u.searchParams.has('primary_color')) u.searchParams.set('primary_color', 'e60023');
    } else if (/(^|\.)cal\.com$/.test(host)) {
      if (!/\/embed\/?$/.test(u.pathname)) u.pathname = u.pathname.replace(/\/$/, '') + '/embed';
      u.searchParams.set('embedType', 'inline');
      u.searchParams.set('layout', 'month_view');
    } else if (/calendar\.google\.com$/.test(host)) {
      u.searchParams.set('gv', 'true');
    }
    return u.toString();
  }
  function mountFrame(container) {
    if (!container || !bookUrl || container.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = embedUrl(bookUrl);
    f.title = 'Book a free strategy call with Scalypin';
    f.loading = 'eager';
    f.addEventListener('load', function () { var l = container.querySelector('.sp-book__loading'); if (l) l.hidden = true; });
    container.appendChild(f);
  }
  var dialog = document.querySelector('[data-sp-book-dialog]');
  var lastTrigger = null;
  function closeBook() {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }
  if (dialog) {
    dialog.addEventListener('close', function () {
      doc.classList.remove('sp-modal-open');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeBook(); });
    dialog.querySelectorAll('[data-sp-book-close]').forEach(function (b) { b.addEventListener('click', closeBook); });
  }
  var inlineBook = document.querySelector('[data-sp-book-inline]');
  function openBook(trigger) {
    if (inlineBook) {
      inlineBook.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    lastTrigger = trigger || null;
    mountFrame(dialog.querySelector('[data-sp-book-frame]'));
    doc.classList.add('sp-modal-open');
    dialog.showModal();
    closeMobile();
    Scalypin.track('booking_open', { event_id: uuid(), page: window.location.pathname });
    return true;
  }
  Scalypin.openBooking = openBook;
  function isBookingLink(a) {
    if (a.hasAttribute('data-sp-no-book')) return false;
    if (a.hasAttribute('data-sp-book')) return true;
    var href = a.getAttribute('href') || '';
    if (href === '#book') return true;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (e) { return false; }
    if (u.origin !== window.location.origin) return false;
    var path = u.pathname.replace(/\/$/, '');
    return (path === '/pages/contact' || path === '/contact') && !u.search && (!u.hash || u.hash === '#book');
  }
  if (bookUrl && BOOK.popup !== false) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a');
      if (!a || (dialog && dialog.contains(a))) return;
      if (!isBookingLink(a)) return;
      if (openBook(a)) e.preventDefault();
    });
  }
  if (inlineBook && bookUrl) {
    inlineBook.hidden = false;
    mountFrame(inlineBook.querySelector('[data-sp-book-frame]') || inlineBook);
  }
  if (bookUrl) {
    document.querySelectorAll('[data-sp-book-slot]').forEach(function (el) { el.hidden = false; });
  }
  if (WA) {
    document.querySelectorAll('[data-sp-wa-slot]').forEach(function (el) { el.href = WA; el.hidden = false; });
  }
  document.querySelectorAll('[data-sp-contact-alt]').forEach(function (el) {
    if (el.querySelector('a:not([hidden])')) el.hidden = false;
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sp-wa-link]');
    if (a) Scalypin.track('whatsapp_click', { event_id: uuid(), lead_type: 'WhatsApp', page: window.location.pathname });
  });
  if (window.location.hash === '#book' && bookUrl) {
    window.setTimeout(function () { openBook(null); }, 300);
  }

  /* ---------- Copy buttons ---------- */
  document.querySelectorAll('[data-sp-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-sp-copy');
      var label = btn.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = label; }, 1600);
        }).catch(function () { /* clipboard refused: the address stays visible and selectable */ });
      }
    });
  });
})();
